import { Marker } from 'react-map-gl'

import { css } from '@emotion/react'

import MarkerIcon from '@/components/icons/MarkerIcon'
import CustomPopup from '@/components/parkings/CustomPopup'
import PriceTag from '@/components/parkings/PriceTag'
import { Parking } from '@/service'
import { colors } from '@/styles/theme'
import { selectParkingDisplayPrice } from '@/utils/selectParkingDisplayPrice'

interface Props {
  marker: Parking
  popup?: boolean
  showPopup?: boolean
  customButtons?: boolean
  onClick?(uuid: string): void
}

function CustomMarker(props: Props) {
  const { marker, popup = false, showPopup, onClick, customButtons } = props

  const selectedDisplayPrice = selectParkingDisplayPrice(marker.price)

  return (
    <>
      {popup ? (
        <Marker
          onClick={() => onClick && onClick(marker.uuid)}
          longitude={marker?.lon ?? 0}
          latitude={marker?.lat ?? 0}
          style={{ zIndex: `${showPopup ? 1000 : 0}` }}
        >
          <div css={styles.wrapper}>
            {selectedDisplayPrice ? (
              <div
                css={[
                  styles.priceTagWrapper,
                  showPopup && styles.priceTagWrapperGreen
                ]}
              >
                <MarkerIcon green={showPopup} />
                <PriceTag
                  price={selectedDisplayPrice.price}
                  periodInDays={selectedDisplayPrice.periodInDays}
                />
              </div>
            ) : (
              <MarkerIcon green={showPopup} />
            )}
            {showPopup && (
              <CustomPopup parking={marker} customButtons={customButtons} />
            )}
          </div>
        </Marker>
      ) : marker ? (
        <Marker longitude={marker?.lon ?? 0} latitude={marker?.lat ?? 0}>
          <div css={styles.wrapperIcon}>
            <MarkerIcon />
          </div>
        </Marker>
      ) : (
        <></>
      )}
    </>
  )
}

const styles = {
  wrapper: css`
    cursor: pointer;
    width: 100%;
    height: 100%;
  `,
  priceTagWrapper: css`
    display: flex;
    align-items: center;
    background-color: ${colors.darkSkyBlue};
    padding-inline-end: 12px;
    border-radius: 17px;
    height: 36px;
    overflow: hidden;

    p {
      position: relative;
      margin: 0;
      margin-inline-start: -10px;
      padding: 0;
      background-color: ${colors.darkSkyBlue};
      color: ${colors.white};
    }
  `,
  priceTagWrapperGreen: css`
    background-color: ${colors.greenishCyan};

    p {
      background-color: ${colors.greenishCyan};
      color: ${colors.twilightBlue};
    }
  `,
  wrapperIcon: css`
    background-color: ${colors.darkSkyBlue};
    /* border */
    width: 48px;
    height: 48px;
    border-radius: 17px;

    rect {
      fill: ${colors.darkSkyBlue};
    }

    .legia-warszawa & {
      background-color: var(--mainCustom);
      border-radius: 0;

      rect {
        fill: var(--mainCustom);
      }
    }
  `
}

export default CustomMarker
